import React from 'react';
import PropTypes from 'prop-types';
import {Button, Dialogue, Dropdown, DropdownItem, IconButton} from '@albert-io/atomic';
import {getModelForResourceType} from 'resources/modelRegistry';
import {invalidatePartialInterest} from 'resources/mandark.resource';
import ManageRosterContext from 'client/Classrooms/Classroom/Teacher/ManageRoster/ManageRoster.context';

import ConfirmActionModal from 'client/components/ConfirmActionModal/ConfirmActionModal.react';

export default class InvitedStudentsActionsDropdown extends React.Component {
  static propTypes = {
    invitation: PropTypes.instanceOf(getModelForResourceType('classroom_invitation_v1'))
  };

  constructor() {
    super();

    this.state = {
      showRemoveModal: false,
      showResendModal: false
    };
  }

  handleRemoveInvitation = () => this.props.invitation.delete();

  handleSendInvitation = () => this.props.invitation.setSentEmailAt(null).save();

  handleSuccess = () => {
    invalidatePartialInterest(this.context.queries.invitations.done());
    this.context.setIsReady(false);
  };

  static contextType = ManageRosterContext;

  render() {
    const {invitation} = this.props;
    return (
      <>
        <Dropdown trigger={<IconButton icon='ellipsis-v' label='menu' />} position='bottom-end'>
          <DropdownItem
            as='button'
            icon={['fal', 'envelope']}
            onClick={() =>
              this.setState(({showResendModal}) => ({
                showResendModal: !showResendModal
              }))
            }
          >
            Re-send invitation
          </DropdownItem>
          <DropdownItem
            as='button'
            color='red'
            icon={['fal', 'trash-alt']}
            iconColor='destructive'
            onClick={() =>
              this.setState(({showRemoveModal}) => ({
                showRemoveModal: !showRemoveModal
              }))
            }
          >
            Remove invitation
          </DropdownItem>
        </Dropdown>
        {this.state.showRemoveModal && (
          <ConfirmActionModal
            align='center'
            handleClose={() => this.setState({showRemoveModal: false})}
            makeRequest={this.handleRemoveInvitation}
            onResolve={this.handleSuccess}
          >
            {({isRequestInflight, onCancel, onConfirm}) => (
              <>
                <Dialogue.Body align='center'>
                  Are you sure you want to remove the invitation for
                  <br />
                  <strong>{invitation.getEmail()}</strong>?
                </Dialogue.Body>
                <Dialogue.BtnGroup align='center'>
                  <Button color='secondary' disabled={isRequestInflight} onClick={onCancel}>
                    Cancel
                  </Button>
                  <Button color='destructive' disabled={isRequestInflight} onClick={onConfirm}>
                    Remove
                  </Button>
                </Dialogue.BtnGroup>
              </>
            )}
          </ConfirmActionModal>
        )}
        {this.state.showResendModal && (
          <ConfirmActionModal
            align='center'
            handleClose={() => this.setState({showResendModal: false})}
            makeRequest={this.handleSendInvitation}
            onResolve={this.handleSuccess}
          >
            {({isRequestInflight, onCancel, onConfirm}) => (
              <>
                <Dialogue.Body align='center'>
                  A new invitation to
                  <br />
                  <strong>{this.context.classroom.getName()}</strong> will be sent to
                  <br />
                  <strong>{invitation.getEmail()}</strong>.
                </Dialogue.Body>
                <Dialogue.BtnGroup align='center'>
                  <Button color='secondary' disabled={isRequestInflight} onClick={onCancel}>
                    Cancel
                  </Button>
                  <Button disabled={isRequestInflight} onClick={onConfirm}>
                    Send
                  </Button>
                </Dialogue.BtnGroup>
              </>
            )}
          </ConfirmActionModal>
        )}
      </>
    );
  }
}
